const StudentDashBoardClient = {
  assessment_score: "/assessment/scores",
  assessment_candidate_score: "/candidate_performance",
};

export default StudentDashBoardClient;
